const account_center = {
    header: {
        title: 'مركز الحساب',
    },
    home: {
        title: 'الصفحة غير موجودة',
        description: 'هذه الصفحة غير متاحة.',
    },
    verification: {
        title: 'التحقق الأمني',
        description: 'تحقق من أنك الشخص المقصود لحماية أمان حسابك. يرجى اختيار الطريقة للتحقق من هويتك.',
        error_send_failed: 'فشل إرسال رمز التحقق. يرجى المحاولة لاحقًا.',
        error_invalid_code: 'رمز التحقق غير صالح أو منتهي الصلاحية.',
        error_verify_failed: 'فشل التحقق. يرجى إدخال الرمز مرة أخرى.',
        verification_required: 'انتهت صلاحية التحقق. يرجى التحقق من هويتك مرة أخرى.',
        try_another_method: 'جرّب طريقة أخرى للتحقق',
    },
    password_verification: {
        title: 'التحقق من كلمة المرور',
        description: 'لحماية أمان حسابك، أدخل كلمة المرور للتحقق من هويتك.',
        error_failed: 'فشل التحقق. يرجى التحقق من كلمة المرور.',
    },
    verification_method: {
        password: {
            name: 'كلمة المرور',
            description: 'تحقق من كلمة المرور الخاصة بك',
        },
        email: {
            name: 'رمز التحقق عبر البريد الإلكتروني',
            description: 'أرسل رمز التحقق إلى بريدك الإلكتروني',
        },
        phone: {
            name: 'رمز التحقق عبر الهاتف',
            description: 'أرسل رمز التحقق إلى رقم هاتفك',
        },
    },
    email: {
        title: 'ربط البريد الإلكتروني',
        description: 'اربط بريدك الإلكتروني لتسجيل الدخول أو للمساعدة في استعادة الحساب.',
        verification_title: 'أدخل رمز التحقق من البريد الإلكتروني',
        verification_description: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني {{email_address}}.',
        success: 'تم ربط البريد الإلكتروني الأساسي بنجاح.',
        verification_required: 'انتهت صلاحية التحقق. يرجى التحقق من هويتك مرة أخرى.',
    },
    phone: {
        title: 'ربط رقم الهاتف',
        description: 'اربط رقم هاتفك لتسجيل الدخول أو للمساعدة في استعادة الحساب.',
        verification_title: 'أدخل رمز التحقق عبر الرسائل القصيرة',
        verification_description: 'تم إرسال رمز التحقق إلى هاتفك {{phone_number}}.',
        success: 'تم ربط الهاتف الأساسي بنجاح.',
        verification_required: 'انتهت صلاحية التحقق. يرجى التحقق من هويتك مرة أخرى.',
    },
    username: {
        title: 'تعيين اسم المستخدم',
        description: 'يجب أن يحتوي اسم المستخدم على أحرف وأرقام وشرطات سفلية فقط.',
        success: 'تم تحديث اسم المستخدم بنجاح.',
    },
    password: {
        title: 'تعيين كلمة المرور',
        description: 'أنشئ كلمة مرور جديدة لحماية حسابك.',
        success: 'تم تحديث كلمة المرور بنجاح.',
    },
    code_verification: {
        send: 'إرسال رمز التحقق',
        resend: 'لم تستلمه بعد؟ <a>إعادة إرسال رمز التحقق</a>',
        resend_countdown: 'لم تستلمه بعد؟<span> أعد الإرسال بعد {{seconds}} ث.</span>',
    },
    email_verification: {
        title: 'تحقق من بريدك الإلكتروني',
        prepare_description: 'تحقق من هويتك لحماية أمان حسابك. أرسل رمز التحقق إلى بريدك الإلكتروني.',
        email_label: 'عنوان البريد الإلكتروني',
        send: 'إرسال رمز التحقق',
        description: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني {{email}}. أدخل الرمز للمتابعة.',
        resend: 'لم تستلمه بعد؟ <a>إعادة إرسال رمز التحقق</a>',
        resend_countdown: 'لم تستلمه بعد؟<span> أعد الإرسال بعد {{seconds}} ث.</span>',
        error_send_failed: 'فشل إرسال رمز التحقق. يرجى المحاولة لاحقًا.',
        error_verify_failed: 'فشل التحقق. يرجى إدخال الرمز مرة أخرى.',
        error_invalid_code: 'رمز التحقق غير صالح أو منتهي الصلاحية.',
    },
    phone_verification: {
        title: 'تحقق من هاتفك',
        prepare_description: 'تحقق من هويتك لحماية أمان حسابك. أرسل رمز التحقق إلى هاتفك.',
        phone_label: 'رقم الهاتف',
        send: 'إرسال رمز التحقق',
        description: 'تم إرسال رمز التحقق إلى هاتفك {{phone}}. أدخل الرمز للمتابعة.',
        resend: 'لم تستلمه بعد؟ <a>إعادة إرسال رمز التحقق</a>',
        resend_countdown: 'لم تستلمه بعد؟<span> أعد الإرسال بعد {{seconds}} ث.</span>',
        error_send_failed: 'فشل إرسال رمز التحقق. يرجى المحاولة لاحقًا.',
        error_verify_failed: 'فشل التحقق. يرجى إدخال الرمز مرة أخرى.',
        error_invalid_code: 'رمز التحقق غير صالح أو منتهي الصلاحية.',
    },
    mfa: {
        totp_already_added: 'لقد أضفت تطبيق مصادقة بالفعل. يرجى إزالة التطبيق الحالي أولاً.',
        totp_not_enabled: 'تطبيق المصادقة غير مفعّل. يرجى التواصل مع المسؤول لتفعيله.',
        backup_code_already_added: 'لديك بالفعل رموز احتياطية نشطة. يرجى استخدامها أو إزالتها قبل إنشاء رموز جديدة.',
        backup_code_not_enabled: 'رمز النسخ الاحتياطي غير ممكّن. يرجى الاتصال بالمسؤول لتمكينه.',
        backup_code_requires_other_mfa: 'تتطلب رموز النسخ الاحتياطي إعداد طريقة MFA أخرى أولاً.',
        passkey_not_enabled: 'مفتاح المرور غير مفعّل. يرجى التواصل مع المسؤول لتفعيله.',
    },
    update_success: {
        default: {
            title: 'تم التحديث!',
            description: 'تم تحديث معلوماتك.',
        },
        email: {
            title: 'تم تحديث البريد الإلكتروني!',
            description: 'تم تحديث عنوان بريدك الإلكتروني بنجاح.',
        },
        phone: {
            title: 'تم تحديث رقم الهاتف!',
            description: 'تم تحديث رقم هاتفك بنجاح.',
        },
        username: {
            title: 'تم تغيير اسم المستخدم!',
            description: 'تم تحديث اسم المستخدم الخاص بك بنجاح.',
        },
        password: {
            title: 'تم تغيير كلمة المرور!',
            description: 'تم تحديث كلمة المرور الخاصة بك بنجاح.',
        },
        social: {
            title: 'تم ربط الحساب الاجتماعي!',
            description: 'تم ربط حسابك الاجتماعي بنجاح.',
        },
        totp: {
            title: 'تمت إضافة تطبيق المصادقة!',
            description: 'تم ربط تطبيق المصادقة بحسابك بنجاح.',
        },
        backup_code: {
            title: 'تم إنشاء رموز النسخ الاحتياطي!',
            description: 'تم حفظ رموز النسخ الاحتياطي الخاصة بك. احتفظ بها في مكان آمن.',
        },
        backup_code_deleted: {
            title: 'تم حذف رموز النسخ الاحتياطي!',
            description: 'تم حذف رموز النسخ الاحتياطي من حسابك.',
        },
        passkey: {
            title: 'تمت إضافة مفتاح المرور!',
            description: 'تم ربط مفتاح المرور بحسابك بنجاح.',
        },
        passkey_deleted: {
            title: 'تم حذف مفتاح المرور!',
            description: 'تم حذف مفتاح المرور من حسابك.',
        },
    },
    backup_code: {
        title: 'رموز النسخ الاحتياطي',
        description: 'يمكنك استخدام أحد رموز النسخ الاحتياطي هذه للوصول إلى حسابك إذا واجهت مشكلة أثناء التحقق بخطوتين بطرق أخرى. يمكن استخدام كل رمز مرة واحدة فقط.',
        copy_hint: 'تأكد من نسخها وحفظها في مكان آمن.',
        generate_new_title: 'إنشاء رموز نسخ احتياطي جديدة',
        generate_new: 'إنشاء رموز نسخ احتياطي جديدة',
        delete_confirmation_title: 'حذف رموز النسخ الاحتياطي',
        delete_confirmation_description: 'إذا قمت بحذف رموز النسخ الاحتياطي هذه، فلن تتمكن من استخدامها للتحقق.',
    },
    passkey: {
        title: 'مفاتيح المرور',
        added: 'تمت الإضافة: {{date}}',
        last_used: 'آخر استخدام: {{date}}',
        never_used: 'أبدًا',
        unnamed: 'مفتاح مرور بدون اسم',
        renamed: 'تم تغيير اسم مفتاح المرور بنجاح.',
        add_another_title: 'إضافة مفتاح مرور آخر',
        add_another_description: 'قم بتسجيل مفتاح المرور الخاص بك باستخدام المقاييس الحيوية للجهاز أو مفاتيح الأمان (مثل YubiKey) أو الطرق الأخرى المتاحة.',
        add_passkey: 'إضافة مفتاح مرور',
        delete_confirmation_title: 'حذف مفتاح المرور',
        delete_confirmation_description: 'هل أنت متأكد أنك تريد حذف "{{name}}"؟ لن تتمكن من استخدام مفتاح المرور هذا لتسجيل الدخول بعد الآن.',
        rename_passkey: 'إعادة تسمية مفتاح المرور',
        rename_description: 'أدخل اسمًا جديدًا لمفتاح المرور هذا.',
    },
};
export default Object.freeze(account_center);
